import React from 'react'

const TypeWarn = (props) => {

    return(

        <div id='TypeWarn'>

            <p>{ props.message }</p>

        </div>

    )
}

export default TypeWarn





// WEBPACK FOOTER //
// ./src/components/type/TypeWarn.js